import type { ScreenSchema } from './types';

/**
 * Schema for the `bank` template (screen-bank.vue).
 *
 * Same reasoning as screen-quiz.schema.ts: the bank creates nested
 * uc-scroll-sections for each question that are inner (non-top-level) sections.
 * screen-bank.vue injects the outer sectionActive to play the first question's
 * intro (JiT or S3) on initial section entry.
 */
const bankSchema: ScreenSchema = {
  template: 'bank',
  managesOwnSectionAudio: true,
  slots: {}
};

export default bankSchema;
